import { render, staticRenderFns } from "./ProductSetPage.vue?vue&type=template&id=0b85ee10&scoped=true&"
import script from "./ProductSetPage.vue?vue&type=script&lang=js&"
export * from "./ProductSetPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductSetPage.vue?vue&type=style&index=0&id=0b85ee10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b85ee10",
  null
  
)

export default component.exports